<div class="fb-product-description mt-4 px-2 xl:px-0">
	<div class="mb-3">
		<div class="space-y-4">
			<div class="flex items-center">
				<h2 class="font-medium text-gray-800">Key Features</h2>
			</div>
			<div *ngIf="product.badgeProfileEnabled && product.badgeProfile"
				 class="bg-[#f9f7f4] rounded-lg p-4">

				<ul class="space-y-2">
					<div class="flex justify-evenly flex-wrap gap-2 items-center text-sm text-gray-700">
						<ng-container *ngFor="let badgeProfile of product.badgeProfile.badgeProfileItemList; let i = index">
							<ng-container *ngIf="badgeProfile.link && badgeProfile.link !== 'https://anuprerna.com/'">
								<a href="{{badgeProfile.link}}" target="_blank"
								   class="text-center flex flex-col justify-center items-center gap-1">
									<div class="overflow-hidden rounded-full w-[35px] md:w-[50px] h-[35px] md:h-[50px]">
										<img class="w-full h-full object-cover" [src]="badgeProfile.image" />
									</div>
									<p class="text-[12px]">
										{{badgeProfile.caption}}
									</p>
								</a>
							</ng-container>
							<ng-container *ngIf="!badgeProfile.link || badgeProfile.link === 'https://anuprerna.com/'">
								<div class="text-center flex flex-col justify-center items-center gap-1">
									<div class="overflow-hidden rounded-full w-[35px] md:w-[50px] h-[35px] md:h-[50px]">
										<img class="w-full h-full object-cover" [src]="badgeProfile.image" />
									</div>
									<p class="text-[12px]">
										{{badgeProfile.caption}}
									</p>
								</div>
							</ng-container>
						</ng-container>
					</div>
				</ul>
			</div>

			<div class=" text-gray-700 text-sm md:text-base">
				<p [innerHTML]="product.productOverview"></p>
			</div>

<!--			<div class="bg-white border border-gray-100 rounded-lg p-4">-->
<!--				<div class="flex items-center mb-2">-->
<!--					<i class="fas fa-magic text-[#7D5A20] mr-2"></i>-->
<!--					<h2 class="font-medium text-gray-800">Perfect For</h2>-->
<!--				</div>-->
<!--				<div class="grid grid-cols-2 gap-2 mt-2">-->
<!--                      <span class="text-sm bg-[#f9f7f4] text-gray-700 px-3 py-1.5 rounded-full text-center">-->
<!--                        Sarees-->
<!--                      </span>-->
<!--					<span class="text-sm bg-[#f9f7f4] text-gray-700 px-3 py-1.5 rounded-full text-center">-->
<!--                        Dresses-->
<!--                      </span>-->
<!--					<span class="text-sm bg-[#f9f7f4] text-gray-700 px-3 py-1.5 rounded-full text-center">-->
<!--                        Home Decor-->
<!--                      </span>-->
<!--					<span class="text-sm bg-[#f9f7f4] text-gray-700 px-3 py-1.5 rounded-full text-center">-->
<!--                        Accessories-->
<!--                      </span>-->
<!--				</div>-->
<!--			</div>-->
		</div>
	</div>
	<div class="mb-3">
		<h2 class="text-base font-medium mb-2">
			Material Composition
		</h2>
		<div class="bg-[#F7F4F5] p-4 rounded-lg">
			<div class="flex justify-between mb-2">
				<span class="text-gray-700">{{product.productGroup === 'finished'? 'Product': 'Craft'}}</span>
				<a [href]="getSubCategoryUrl(product)"
					 target="_blank"
					 class="flex items-center gap-1">
					<div class="font-medium capitalize">
						{{product.subCategory.name.toLowerCase()}}
					</div>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.75 12.25V1.75H6.69375V2.625H2.625V11.375H11.375V7.30625H12.25V12.25H1.75ZM5.57083 9.05625L4.95833 8.42917L10.7625 2.625H7.56875V1.75H12.25V6.43125H11.375V3.25208L5.57083 9.05625Z" fill="#4E4E4E"/>
					</svg>
				</a>
			</div>
			<div class="flex justify-between mb-2">
				<span class="text-gray-700">Material</span>
				<div class="flex items-center gap-1">
					<a href="/products/{{product.productGroup === 'finished'? 'finished': 'fabric'}}?material={{prepareUrl(material.name)}}"
					   target="_blank"
					   *ngFor="let material of product.materials; let i= index"
						  class="font-medium flex items-center gap-0.5">
						{{material.name}}
						<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1.75 12.25V1.75H6.69375V2.625H2.625V11.375H11.375V7.30625H12.25V12.25H1.75ZM5.57083 9.05625L4.95833 8.42917L10.7625 2.625H7.56875V1.75H12.25V6.43125H11.375V3.25208L5.57083 9.05625Z" fill="#4E4E4E"/>
						</svg>

						<i *ngIf="product.materials.length > 1 && ((i+1)!=product.materials.length)">,</i>&nbsp;
					</a>
				</div>
			</div>
			<div *ngIf="product.patterns && product.patterns.length > 0"
				 class="flex justify-between mb-2">
				<span class="text-gray-700">Pattern</span>
				<div class="flex items-center gap-1">
					<a href="/products/{{product.productGroup === 'finished'? 'finished': 'fabric'}}?pattern={{prepareUrl(pattern.name)}}"
					   target="_blank"
					   *ngFor="let pattern of product.patterns; let i= index"
						  class="font-medium flex items-center gap-0.5">
						{{pattern.name}}
						<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1.75 12.25V1.75H6.69375V2.625H2.625V11.375H11.375V7.30625H12.25V12.25H1.75ZM5.57083 9.05625L4.95833 8.42917L10.7625 2.625H7.56875V1.75H12.25V6.43125H11.375V3.25208L5.57083 9.05625Z" fill="#4E4E4E"/>
						</svg>
						<i *ngIf="product.patterns.length > 1 && ((i+1)!=product.patterns.length)">,</i>&nbsp;
					</a>
				</div>

			</div>


		</div>
	</div>
	<div class="mb-3">
		<h2 class="text-base font-medium mb-3">Care Instructions</h2>
<!--		<ul class="text-gray-700 text-sm space-y-2">-->
<!--			<li class="flex items-start">-->
<!--				<i class="fas fa-tint text-[#7D5A20] mt-1 mr-2"></i>-->
<!--				<span>Dry clean only</span>-->
<!--			</li>-->
<!--			<li class="flex items-start">-->
<!--				<i class="fas fa-sun text-[#7D5A20] mt-1 mr-2"></i>-->
<!--				<span>Avoid direct sunlight exposure</span>-->
<!--			</li>-->
<!--			<li class="flex items-start">-->
<!--				<i class="fas fa-iron text-[#7D5A20] mt-1 mr-2"></i>-->
<!--				<span>Iron on low heat if necessary</span>-->
<!--			</li>-->
<!--			<li class="flex items-start">-->
<!--				<i class="fas fa-box text-[#7D5A20] mt-1 mr-2"></i>-->
<!--				<span>Store in a cool, dry place</span>-->
<!--			</li>-->
<!--		</ul>-->
		<div class="text-gray-700 text-sm" [innerHTML]="product.productCare | safeHtml"></div>
	</div>
</div>
